"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trades = void 0;
const client_1 = require("@arkecosystem/client");
class Trades extends client_1.Resource {
    async all(query) {
        return this.sendGet("nft/exchange/trades", query);
    }
    async get(id) {
        return this.sendGet(`nft/exchange/trades/${id}`);
    }
    async search(payload, query) {
        return this.sendPost("nft/exchange/trades/search", payload, query);
    }
}
exports.Trades = Trades;
//# sourceMappingURL=trades.js.map